module.exports = __webpack_public_path__ + "img/16.b1f8248e.jpg";